import { ProgrammeStatusType } from '../types';
import { ChipProps } from '@thirdspacelearning/library';

export const statusMap: Record<ProgrammeStatusType, ChipProps['color']> = {
    [ProgrammeStatusType.LIVE]: 'success',
    [ProgrammeStatusType.ARCHIVED]: 'warning',
    // [ProgrammeStatus.TESTING]: 'info', TODO: temporarily disabled
    [ProgrammeStatusType.DRAFT]: 'default',
};
